import type { Lead, HistoryEntry } from '../components/lead-card';
import type { NoteMutation } from './lead-update';
import { getLeadNotes, getLeadAppends } from './lead-update';

export interface NoteDraft {
  newNote: string;
  editingNote: string | null;
  editContent: string;
  editOriginalContent: string;
  saving: boolean;
}
export const emptyNoteDraft: NoteDraft = { newNote: '', editingNote: null, editContent: '', editOriginalContent: '', saving: false };
export type NoteUpdateHandler = (leadId: string, mutation: NoteMutation, history: HistoryEntry) => void;

// Apply only the acknowledged note change to the current UI record.
export function mergeNoteUpdate(lead: Lead, mutation: NoteMutation, history: HistoryEntry): Lead {
  const notes = getLeadNotes(lead);
  const notesHistory = mutation.type === 'add'
    ? notes.some(note => note.id === mutation.note.id) ? notes : [mutation.note, ...notes]
    : mutation.type === 'delete'
      ? notes.filter(note => note.id !== mutation.noteId)
      : notes.map(note => note.id === mutation.noteId ? { ...note, content: mutation.content } : note);
  return { ...lead, notes: '', notesHistory, history: [...(lead.history || []), history] };
}

export function finishNoteSave(current: NoteDraft, submitted: NoteDraft, editing: boolean): NoteDraft {
  if (editing) {
    return current.editingNote === submitted.editingNote && current.editContent === submitted.editContent
      ? { ...current, saving: false, editingNote: null, editContent: '', editOriginalContent: '' }
      : current.editingNote === submitted.editingNote
        ? { ...current, saving: false, editOriginalContent: submitted.editContent.trim() }
        : { ...current, saving: false };
  }
  return { ...current, saving: false, newNote: current.newNote === submitted.newNote ? '' : current.newNote };
}

export function mergeSavedLead(current: Lead, update: Partial<Lead>, original: Lead): Lead {
  const appends = getLeadAppends(update, original);
  const { notesHistory: _notes, history: _history, ...fields } = update;
  const notes = getLeadNotes(current);
  const history = current.history || [];
  return {
    ...current, ...fields,
    notesHistory: [...appends.notes.filter(note => !notes.some(existing => existing.id === note.id)), ...notes],
    history: [...history, ...appends.history.filter(entry => !history.some(existing => JSON.stringify(existing) === JSON.stringify(entry)))],
  };
}
